import React from 'react';
import { styled } from '@mui/material/styles';
import { MarkdownRenderer } from '@lialo/pwa-ui/lib/MarkdownRenderer';
import { ReadMore } from './ReadMore';
import { MediaLink } from './MediaLink/MediaLink';

const StyledMarkdownRenderer = styled(MarkdownRenderer)(() => ({
  overflowWrap: 'break-word',
  wordWrap: 'break-word',

  msWorkBreak: 'normal',
  wordBreak: 'normal',

  MsHyphens: 'auto',
  MozHyphens: 'auto',
  WebkitHyphens: 'auto',
  hyphens: 'auto',
}));

interface IProps {
  source: string;
}

const disallowedInline = [
  // 'url',
  // 'email',
  // 'link',
  // 'break',
  // 'text',
  // 'strong',
  // 'deletion', (used for non-translatable text)
  // 'emphasis',

  'escape',
  'autoLink',
  'html',
  'reference',
  'code',
];

const disallowedBlock = [
  // 'blankLine',
  // 'blockquote',
  // 'list',
  // 'paragraph',

  'definition',
  'fencedCode',
  'atxHeading',
  'thematicBreak',
  'setextHeading',
  'html',

  'indentedCode',
  'table',
];

const TourTextRenderer = (props: IProps) => {
  const [main, ...collapsed] = props.source.split(/{{readmore}}/i);

  return (
    <>
      <StyledMarkdownRenderer
        source={main}
        disallowedBlock={disallowedBlock}
        disallowedInline={disallowedInline}
        LinkComponent={MediaLink}
      />
      {collapsed.length > 0 && (
        <ReadMore>
          <TourTextRenderer source={collapsed.join('')} />
        </ReadMore>
      )}
    </>
  );
};

export default TourTextRenderer;
